import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getMonthlyCustomersEarnings } from 'services/RewardsService'
import { GetMonthlyCustomersEarningsParams } from 'types/rewards'

interface UseMonthlyCustomersEarningsQueryOptions extends GetMonthlyCustomersEarningsParams {
  enabled?: boolean
}

export const useMonthlyCustomersEarningsQuery = ({
  currency,
  startDate,
  endDate,
  pageNumber,
  pageSize,
  enabled = true,
}: UseMonthlyCustomersEarningsQueryOptions) => {
  return useQuery({
    queryKey: reactQueryKeys.monthlyCustomersEarnings(
      currency,
      startDate,
      endDate,
      pageNumber,
      pageSize
    ),
    queryFn: () =>
      getMonthlyCustomersEarnings({ currency, startDate, endDate, pageNumber, pageSize }),
    enabled: enabled && !!currency,
  })
}
